<template lang="html">
  <div class="si">
    <img class="banner" :src="`${pagebase}/static/img/si2/modNo1.png`" alt="">
    <img class="modNo" :src="`${pagebase}/static/img/si2/modNo2.png`" alt="">
    <img class="modNo" :src="`${pagebase}/static/img/si2/modNo3.png`" alt="">
    <img class="modNo" :src="`${pagebase}/static/img/si2/modNo4.png`" alt="">
    <img class="modNo" :src="`${pagebase}/static/img/si2/modNo5.png`" alt="">
    <img class="modNo" :src="`${pagebase}/static/img/si2/modNo6.png`" alt="">
    <img class="modNo" :src="`${pagebase}/static/img/si2/modNo7.png`" alt="">
    
    <img :src="`${pagebase}/static/img/si/consulting.png`" alt="" class="consultingIcon" @click="arrangeShow">
    <div class="footerMod">
      <div class="signUp">
        <div class="signUpPrice">
          <p class="originalCost">价格：<span>{{activityCon.cash_price}}</span></p>
        </div>
        <div class="signUpBtn" @click="signUp">立即报名</div>
      </div>
    </div>
    
    <div class="consult_alert" v-bind:class="{'arrangeshow': arrangeshow}" @click="consultClose">
      <div class="consult_alert_con">
        <div class="consult_alert_ma">
          <p>保存识别二维码</p>
          <p>发送“SIPI”咨询入营</p>
          <img class="" :src="`${pagebase}/static/img/si2/qrCode.png`" alt="">
        </div>
        <div class="consult_close_btn">
          <img class="" :src="`${pagebase}/static/img/si/close.png`" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {pagebase} from '@/utils/http.js';
  import utils from '@/utils/utils';
  import WxShare from '@/utils/wxshare';

  export default {
    data() {
      return {
        aid: this.$route.query.aid || '',
        activityCon: {},
        arrangeshow: false,
        pagebase: pagebase,
        listShow: false,
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.showStat();
        // 微信分享
        this.wxshare = new WxShare();
        this.getactivityCon();
      },
      showStat() {
        this.$http({
          url: '/api/showStat',
          method: 'post',
          params: {
            url: window.location.href,
          }
        })
      },
      getactivityCon() {
        this.$http({
          url: '/activity/Info',
          method: 'get',
          params: {
            activity_id: this.aid,
          },
        }).then(res => {
          if (res.code >= 0) {
            let data = res.data;
            this.activityCon = data;
            document.title = data.title;
            this.wxshare.share({
              title: data.title,
              desc: data.summary,
              link: window.location.href,
              imgUrl: data.cover,
            })
          }
        })
      },

      signUp() {
        var succeedUrl = encodeURIComponent(pagebase + '/#/paySucceed?activity_id=' + this.aid);
        if (utils.browserChecker.isWx()) {
          var channel = this.$route.query.channel || '';
          var open = encodeURIComponent(pagebase + '/#/payment?activity_id=' + this.aid + '&project=pcblayout' + '&channel=' + channel + '&succeed_url=' + succeedUrl);
          var url = 'http://edu.eda365.com/wechat_redirect.php?jump_url=' + open;
          window.location.href = url;
        } else {
          this.$router.push({
            path: '/payment',
            query: {
              activity_id: this.aid,
              channel: this.$route.query.channel || '',
              project: 'pcblayout',
              track_id: this.$route.query.track_id || '',
              succeed_url: succeedUrl,
            }
          })
        }
      },

      arrangeShow() {
        this.arrangeshow = true;
      },

      consultClose() {
        this.arrangeshow = false;
      },

      getCourse() {
        this.listShow = true;
      },

      closeCourse() {
        this.listShow = false;
      },
    }
  }
</script>

<style lang="css" scoped>
  .si {
    position: relative;
    padding-bottom: 7.5rem;
  }

  .banner {
    width: 100%;
  }
  
  .modNo {
    margin-top: -.25em;
    width: 100%;
  }
  
  .footerMod {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 8rem;
    background: linear-gradient(to bottom, rgba(13, 43, 72, 0.8), rgba(13, 43, 72, 1));
    z-index: 10;
  }
  
  .consultingIcon {
    width: 7.2rem;
    height: 7.2rem;
    position: fixed;
    right: 1rem;
    bottom: 8.5rem;
    z-index: 10;
  }
  
  .signUp {
    height: 3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: rgba(13, 43, 72, 0.01);
    box-sizing: border-box;
    padding: 0 3rem;
    margin-top: 1rem;
  }
  
  .signUpPrice {
    display: flex;
    height: 2rem;
    align-items: flex-end;
  }
  
  .originalCost {
    font-size: 1.6rem;
    color: #FFFFFF;
    margin-right: 1rem;
  }
  
  .originalCost span {
    color: #FFC851;
  }
  
  .currentPrice {
    font-size: 1rem;
    color: #CCCCCC;
  }
  
  .currentPrice span {
    color: #FFFFFF;
  }
  
  .signUpBtn {
    width: 10rem;
    height: 3rem;
    line-height: 3rem;
    border-radius: 3rem;
    background-color: #B68043;
    text-align: center;
    font-size: 1.6rem;
    color: #FFFFFF;
  }
  
  .consult_alert {
    display: none;
    z-index: 11;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
  }
  
  .consult_alert_con {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -14rem;
    margin-left: -14rem;
    width: 28rem;
    height: 28rem;
    background-color: #F3F7FC;
    border-radius: 1rem;
  }
  
  .consult_alert_ma {
    height: 100%;
    display: flex;
    font-size: 1.8rem;
    font-weight: 600;
    color: #080943;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  
  .consult_alert_ma img {
    width: 15rem;
    height: 15rem;
  }
  
  .arrangeshow {
    display: block;
  }
  
  .consult_close_btn {
    margin-top: .5rem;
    display: flex;
    justify-content: center;
  }
  
  .consult_close_btn img {
    width: 3.8rem;
    height: 3.8rem;
  }
  
  @media (min-width: 751px) {
    .consultingIcon{
      right: 50%;
      margin-right: -375px;
    }
    
    .footerMod {
      width: 750px;
      left: 50%;
      margin-left: -375px;
    }
  }
</style>